import { createSelector } from '@reduxjs/toolkit';
import { useGetOrganisationUsersQuery } from 'features/security/authApi';
import { useMemo } from 'react';

import HelperFunctions from '../pages/global/HelperFunctions';
import { useActiveOrganisation } from './useActiveOrganisation';

/**
 * @param {boolean} activeOnly
 * @returns {import('models/auth.models').OrganisationUser[]}
 */
export function useGetOrganisationUsers(activeOnly = false) {
    const activeOrganisation = useActiveOrganisation();

    const selectUsers = useMemo(() => {
        const emptyArray = [];

        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (res, activeOnly) => activeOnly,
            (data, activeOnly = false) => {
                const users = data ? [...data].sort(HelperFunctions.sortByString('fullName')) : emptyArray;

                if (activeOnly) {
                    return users.filter((user) => user.enabled);
                }

                return users;
            },
        );
    }, []);

    const { users } = useGetOrganisationUsersQuery(activeOrganisation, {
        selectFromResult: (result) => ({
            users: selectUsers(result, activeOnly),
        }),
    });

    return users;
}
